import { Directive, EventEmitter, HostListener, Output } from '@angular/core';
import { debounceTime, Subject } from 'rxjs';

@Directive({
  selector: '[debouncedInput]',
})
export class DebouncedInputDirective {
  @Output() debouncedInput = new EventEmitter<string>();
  private inputSubject = new Subject<string>();

  constructor() {
    this.inputSubject
      .pipe(debounceTime(800))
      .subscribe((value) => {
        this.debouncedInput.emit(value);
      });
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const target = event.target as HTMLInputElement | null;
    const value = target?.value ?? '';
    this.inputSubject.next(value);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    // espera o browser aplicar o texto no input
    setTimeout(() => {
      const target = event.target as HTMLInputElement | null;
      const value = target?.value ?? '';
      this.inputSubject.next(value);
    }, 0);
  }
}
